


import {Component, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import {PRINT_UPDATE_PARAMS} from '@/store/modules/print/types';

@Component
export default class ReportPrintPage extends Vue {
  @Action(PRINT_UPDATE_PARAMS) updatePrintParams: Function;

  created() {
    const params = {
      reportName: this.$route.params.reportName,
      subReportName: this.$route.params.subReportName,
      filters: null,
      reports: null,
      dialog: 0
    };

    if (this.$route.query) {
      params.filters = this.$route.query.filters ? JSON.parse(<string>this.$route.query.filters) : null;
      params.reports = this.$route.query.reports ? JSON.parse(<string>this.$route.query.reports) : null;
      params.dialog = this.$route.query.dialog ? Number(this.$route.query.dialog) : 0;
    }

    this.updatePrintParams(params);
    this.$router.push('/printing');
  }
}
